import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m16 6 4 14", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 6v14", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8 8v12", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M4 4v16", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Library";
const Library = memo(themed(Icon));
export {
  Library
};
//# sourceMappingURL=library.js.map
